// Which screen to open first, and how a deep link survives the sign-in redirect.

export type InitialScreen =
  | { screen: 'new' }
  | { screen: 'history' }
  | { screen: 'detail'; orderId: string; submitted: boolean }

/** The key is namespaced so it can never collide with the sign-in library's own (`oidc.`) session entries. */
const KEY = 'hearingaid.deepLink'

/**
 * `search` is `location.search`: `?order=<id>` opens that order; `&submitted=1` shows the success
 * banner; `?view=history` opens Order history; anything else opens a new order.
 */
export function initialScreen(search: string): InitialScreen {
  const params = new URLSearchParams(search)
  const orderId = params.get('order')
  if (orderId) return { screen: 'detail', orderId, submitted: params.get('submitted') === '1' }
  if (params.get('view') === 'history') return { screen: 'history' }
  return { screen: 'new' }
}

/** The address a screen lives at; `initialScreen(urlFor(s).slice(1))` round-trips. */
export function urlFor(s: InitialScreen): string {
  if (s.screen === 'history') return '/?view=history'
  if (s.screen === 'detail')
    return `/?order=${encodeURIComponent(s.orderId)}${s.submitted ? '&submitted=1' : ''}`
  return '/'
}

/** Call before the sign-in redirect: the round trip drops the query string. Pass sessionStorage. */
export function rememberDeepLink(storage: Storage, search: string): void {
  if (search) storage.setItem(KEY, search)
}

/** Call after the redirect. Returns the remembered query once, then forgets it. */
export function recallDeepLink(storage: Storage): string | null {
  const value = storage.getItem(KEY)
  if (value !== null) storage.removeItem(KEY)
  return value
}
